import axios from 'axios';
import {IQ_API_V2_BASE_URL} from '../config/apiConfig';


const iq_api_v2 = axios.create({
  baseURL: IQ_API_V2_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
iq_api_v2.interceptors.request.use(
  config => {
    // You can modify the config before sending the request, like adding authorization token
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log('Request:', config); // Log the request for debugging
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
iq_api_v2.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      switch (error.response.status) {
        case 401:
          // Handle unauthorized access (e.g., redirect to login)
          console.error('Unauthorized access - perhaps redirect to login');
          break;
        case 403:
          // Handle forbidden access
          console.error('Forbidden access');
          break;
        case 404:
          // Handle not found
          console.error('Resource not found');
          break;
        case 500:
          // Handle internal server error
          console.error('Internal server error');
          break;
        default:
          // Handle other status codes
          console.error(`Error: ${error.response.status}`, error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error', error.message);
    }

    // Return a rejected promise to propagate the error
    return Promise.reject(error);
  }
);



export async function fetchConvertToWin(ids, userId,postCall=()=>null) {
  console.log("fetchConvertToWin ids", ids);
  try {
    const response = await iq_api_v2.post(
      "opportunities/convert_to_win",
      {
        opportunities_id: ids,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    postCall()
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}


export async function deleteMemoryByRecordId(recordID) {
  console.log("deleteMemoryByRecordId ids", recordID);
  try {
    const response = await iq_api_v2.delete("build_memory/delete_memory", {
      params: {
        record_id: recordID
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
  }
}



export async function fetchSpotOpportunity(clientName, accountName, userId,type) {
  const data = {
    client: clientName,
    account: accountName,
    user_id: userId,
    type: type
  };

  // console.log("data",data)
  try {
    const response = await iq_api_v2.post('/opportunities/fetch', {}, {"params" : data} );
    // console.log("response : ", response);

    // console.log('Response:', response.data);
    return response?.data
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}

export async function fetchPitchWoOpportunity(opportunityId) {
  try {
    const response = await iq_api_v2.post('/opportunities/get_pitch', null, {
      params: { opportunity_id: opportunityId }
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}


export async function handleRefreshMem({opportunityId}){
  const data = {
    opportunity_id: opportunityId,
  };

  // console.log("data",data)
  try {
    const response = await iq_api_v2.post('opportunities/refresh_opportunity_by_memory', {}, {"params" : data} );

    return response?.data
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
  }
}


export async function spotContactBC(contactId,userId) {
    try {
      const response = await iq_api_v2.get("spot_contacts/get_contact_details", {
        params: { contact_id: contactId,user_id:userId },
      });
      return response?.data;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  }

export async function deleteOpportunity(userId, opportunityId) {
  try {
    const response = await iq_api_v2.delete("opportunities/delete", {
      params: {
        user_id: userId,
        opportunity_id: opportunityId,
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
}


export async function enrichContact(userId, apolloId, linkedInUrl,onSuccess=()=>null,onError=()=>null) {
  try {
    const response = await iq_api_v2.post("contact/enrich_contact", {
      apollo_user_id: apolloId,
      user_id: userId,
    });
    await onSuccess();
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    await onError();

  }
}



export async function markReadByUser(userId, opportunityId) {
  try {
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("opportunity_id", opportunityId);

    const response = await iq_api_v2.patch("opportunities/update_read_status", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);

  }
}

export async function fetchRevenueTeardown(company_name) {
  try {
    const response = await iq_api_v2.get("/revenue/revenue_teardown", {
      params: { competitor: company_name }, 
    });
    return response?.data;
  } catch (error) {
    console.error(
      "Fetch Revenue Teardown error:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
}
  



export default iq_api_v2;
